module.exports = __webpack_public_path__ + "static/media/2019 - 20 Rosenna Mak-min.11ae9e70.jpg";